import { render, staticRenderFns } from "./AbaAnexoConcurso.vue?vue&type=template&id=4b46f398"
import script from "./AbaAnexoConcurso.vue?vue&type=script&lang=ts"
export * from "./AbaAnexoConcurso.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports